import { Outlet } from "react-router-dom";
import CustomSideBar from "../components/CustomSideBar/CustomSideBar";
import Header from "../components/Header/Header";
import { useState, createContext } from "react";
import '../quillRegister';

export const MenuContext = createContext<{ toggleMenu: () => void }>({ toggleMenu: () => {} });

const Main = () => {
    const [menuHidden, setMenuHidden] = useState(false);
    const toggleMenu = () => setMenuHidden((prev) => !prev);
    return (
        <MenuContext.Provider value={{ toggleMenu }}>
            <div className={`app-wraper${menuHidden ? " hidden-menu" : ""}`}>
                <Header />
                <CustomSideBar />
                <Outlet />
            </div>
        </MenuContext.Provider>
    );
}

export default Main;